import './Contain.css';
import Enroll from "./Enroll";
import Login from "./Login";
import Puzzle from '../Games/Puzzle/Puzzle';
import Puzzle2 from '../Games/Puzzle/Puzzle2';
import AlbumS0 from './AlbumS0';
import AlbumS1 from './AlbumS1';
import AlbumS2 from './AlbumS2';

export default function Contain(props) {
    const ContainInfo = props.ContainInfo;

    if (ContainInfo==="Enroll"){
        return (
        <div className="Contain-Box">
            <Enroll />
        </div>
        );
    }else if (ContainInfo==="Login"){
        return (
        <div className="Contain-Box">
            <Login />
        </div>
        );
    }else if (ContainInfo==="Puzzle"){
        return (
        <div className="Contain-Box">
            <Puzzle2 />
        </div>
        );
    }else if (ContainInfo==="AlbumS0"){
        return (
        <div className="Contain-Box">
            <AlbumS0 />
        </div>
        );
    }else if (ContainInfo==="AlbumS1"){
        return (
        <div className="Contain-Box">
            <AlbumS1 />
        </div>
        );
    }else if (ContainInfo==="AlbumS2"){
        return (
        <div className="Contain-Box">
            <AlbumS2 />
        </div>
        );
    } 
}